import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: flex-start;
   
   .card{
        background: var(--colorBackgroundCardsDashboard);
        width: max-content;
        padding: 0.3rem;
        margin: .1rem;
        font-size: 0.7rem;
        color: var(--colorFontsCardsDashboard);
        font-weight: 500;
        
        ${props => props.isLoading && css`
            width: 180px;
            min-height: 1.3rem;

            p, span{
                display: none;
            }
        `}

        .mobileVersionDate{
            display: none;
        }

        @media (max-width: 500px) {
            .mobileVersionDate{
                display: block;
            }

            .wideVersionDate {
                display: none;
            }
        }
   }
   
   .lastSync {
       position: relative;

        &:hover {
            div{
                display: block;
            }
        }

       div{
            background: var(--colorBackgroundCardsDashboard);
            width: 100%;
            padding: 0.3rem;
            position: absolute;
            bottom: -3px;
            left: 0;
            text-align: center;
            transform: translateY(100%);
            z-index: 99;
            display: none;
            box-shadow: rgb(0 0 0 / 10%) 0px 5px 10px;

            span{
                color: gray;
                font-size: 0.6rem;
            }
        }
    }

   .flexAuto{
       flex: auto;
       display: flex;
       flex-wrap: wrap;
   }

   .atLeast{ 
        padding: 0.8rem 0.3rem 0.3rem 0.3rem;
        position: relative;
        overflow: hidden;
        cursor: pointer;

        span{
            font-size: 0.5rem;
            position: absolute;
            top: 2px;
            left: 2px;
            width: max-content;
        }
    }

    .filterDate{
        cursor: pointer;
        display: flex;
        align-items: center;
        
        @media (max-width: 600px) {
            display: none;
        }
    }
`
